<div class="min-h-screen flex flex-col">
  <app-header></app-header>

  <div id="HTMLContent" class="flex-1 w-[95vw] sm:w-[85vw] md:w-[75vw] lg:w-[65vw] xl:w-[60vw] 2xl:w-[55vw] mx-auto p-2 sm:p-4 md:p-6 lg:p-8 xl:p-10 2xl:p-12">
    @if (!isShortenUrl) {
      <div id="HTML-Row4" class="bg-white rounded-bosch-lg shadow-bosch-md p-bosch-lg md:p-bosch-xl lg:p-8 xl:p-10 2xl:p-12 mb-bosch-lg animate-bosch-fade-in">
        <form>
          <div class="bci-input-group mb-bosch-md">
            <label for="original_url" class="bci-label">Enter link to shorten it</label>
            <input
              type="text"
              placeholder="https://www.bosch.com"
              name="original_url"
              id="original_url"
              [(ngModel)]="originalUrl"
              (keyup)="checkIsValidURL($event)"
              class="bci-input"
              [class.error]="isValidUrlEM"
              [class.success]="isValidUrl"
              aria-describedby="original-url-validation original-url-success"
              required
              />
              @if (isValidUrlEM) {
                <div class="bci-error-text" id="original-url-validation" role="alert" aria-live="polite">
                  <span><span aria-hidden="true">{{ isValid_icon }}</span> {{ isValid_val }}</span>
                </div>
              }
              @if (isValidUrl) {
                <div class="bci-success-text" id="original-url-success" role="status" aria-live="polite">
                  <span><span aria-hidden="true">{{ isValid_icon }}</span> {{ isValid_val }}</span>
                </div>
              }
            </div>
            <div class="bci-input-group">
              <label for="short_link_name" class="bci-label">Custom Short Link (Optional)</label>
              <input
                #input2
                type="text"
                placeholder="..."
                name="short_link_name"
                id="short_link_name"
                [(ngModel)]="shortUrl"
                (keyup)="handleKeyUp()"
                (focus)="onShortUrlFocus()"
                (blur)="onShortUrlBlur()"
                [maxlength]="maxShortUrlLength"
                class="bci-input"
                [class.error]="!(isValidUrl && !isFormDisabled) && shortUrl"
                [class.success]="isValidUrl && !isFormDisabled && shortUrl"
                aria-describedby="short-url-validation short-url-success"
                required
                />
                @if (!(isValidUrl && !isFormDisabled) && shortUrl) {
                  <div class="bci-error-text" id="short-url-validation" role="alert" aria-live="polite">
                    <span><span aria-hidden="true">{{ seeUrlS_icon }}</span> {{ seeUrlS_val }}</span>
                  </div>
                }
                @if (isValidUrl && !isFormDisabled && shortUrl) {
                  <div class="bci-success-text" id="short-url-success" role="status" aria-live="polite">
                    <span><span aria-hidden="true">{{ seeUrlS_icon }}</span> {{ seeUrlS_val }}</span>
                  </div>
                }
              </div>
            </form>
    <div class="bg-bosch-green-100 border border-bosch-green-200 rounded-bosch-md py-1 px-bosch-sm text-black text-sm font-bosch animate-bosch-fade-in" [ngClass]="{
        'block':
          shortUrl?.length === maxShortUrlLength ||
          (shortUrl?.length === 0 && shortUrlInputFocused) ||
          (shortUrl?.length >= 3 && this.timerWaiting),
        'hidden': !(shortUrl?.length === maxShortUrlLength ||
          (shortUrl?.length === 0 && shortUrlInputFocused) ||
          (shortUrl?.length >= 3 && this.timerWaiting))
      }">
              @if (this.timerWaiting && shortUrl?.length >= 3) {
                <span>{{ icon_info }} Checking availability...</span>
              }
              @if (shortUrl?.length === maxShortUrlLength) {
                <span>{{ icon_info }} Maximum of {{ maxShortUrlLength }} characters reached.</span>
              } @else {
                @if (shortUrl?.length === 0 && shortUrlInputFocused) {
                  <span>{{ icon_info }} Empty value is also fine. We will create a random one
                  for you!</span>
                }
              }
            </div>
            <div class="flex gap-bosch-md mt-bosch-lg">
              <div class="flex flex-1">
                <button type="button" class="flex-1 bg-bosch-blue-500 hover:bg-bosch-blue-600 active:bg-bosch-blue-700 text-white font-bosch-medium py-bosch-md px-bosch-lg rounded-bosch-md transition-all duration-200 disabled:bg-bosch-gray-400 disabled:cursor-not-allowed shadow-bosch-sm hover:shadow-bosch-md text-center" name="submit" [disabled]="!isValidUrl || isFormDisabled"
                  (click)="getShortURL()">
                  Create
                </button>
              </div>
              <div class="flex-1 hidden lg:flex">
                <button class="bg-bosch-blue-500 border-2 border-bosch-blue-700 text-white hover:bg-bosch-blue-600 hover:border-bosch-blue-800 font-bosch-medium py-bosch-md px-bosch-lg rounded-bosch-md transition-all duration-200 w-full shadow-bosch-sm hover:shadow-bosch-md text-center" type="submit" name="submit" routerLink="my-links/">
                  Manage my links
                </button>
              </div>
            </div>
          </div>
        }

        @if (isShortenUrl) {
          <div id="HTML-Row5" class="bg-gradient-to-br from-bosch-blue-500 to-bosch-blue-700 rounded-bosch-lg p-bosch-lg md:p-bosch-xl 2xl:p-12 text-white shadow-bosch-lg animate-bosch-fade-in">
            <div class="flex flex-col lg:flex-row items-center gap-bosch-xl">
              <div class="flex-shrink-0">
                <a [href]="qrCodeDownloadLink" class="block bg-white rounded-bosch-lg p-bosch-md hover:shadow-bosch-lg transition-all duration-200 transform hover:scale-105" download="qrcode">
                  <qrcode #qrcode (qrCodeURL)="onChangeURL($event)" [qrdata]="shortenUrl" [allowEmptyString]="true"
                    [ariaLabel]="'QR-Code Image'" [cssClass]="'obj-qrcode'" [colorDark]="'#ffffff'" [colorLight]="'#007bc0'"
                    [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [imageSrc]="" [imageHeight]="" [imageWidth]=""
                  [margin]="2" [scale]="1" [title]="'download QRCode'" [width]="180"></qrcode>
                  <div class="text-center mt-bosch-sm text-bosch-blue-500 text-sm font-bosch-medium">Download QR Code</div>
                </a>
              </div>
              <div class="flex-1 text-center lg:text-left">
                <h2 class="text-bosch-h2 font-bosch-strong mb-bosch-sm">Your Link:</h2>
                <div class="bg-white/10 rounded-bosch-lg p-bosch-md flex items-center gap-bosch-md backdrop-blur-sm border border-white/20">
                  <a href="{{ shortenUrl }}" class="text-white underline break-all flex-1 font-bosch hover:text-white/90 transition-colors">{{ shortenUrl }}</a>
                  <button class="bg-white/20 hover:bg-white/30 active:bg-white/40 rounded-bosch-md p-bosch-sm transition-all duration-200 hover:scale-105" (click)="copyContent()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M15 20H4V9H8V10H5V19H14V16H15V20ZM20 13H19V14H18V15H20V13ZM20 10H19V12H20V10ZM20 7H19V9H20V7ZM20 4H18V5H19V6H20V4ZM17 4H15V5H17V4ZM14 4H12V5H14V4ZM10 5H11V4H9V6H10V5ZM10 7H9V9H10V7ZM10 10H9V12H10V10ZM11 14H10V13H9V15H11V14ZM17 14H15V15H17V14ZM14 14H12V15H14V14Z"
                        fill="white" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex flex-col sm:flex-row gap-bosch-md mt-bosch-lg">
                  <button type="submit" name="submit" class="bg-white text-bosch-blue-600 hover:bg-bosch-blue-50 active:bg-bosch-blue-100 font-bosch-medium py-bosch-md px-bosch-lg rounded-bosch-md transition-all duration-200 shadow-bosch-sm hover:shadow-bosch-md text-center" (click)="getToNewShortURL()">
                    <span>Create Again</span>
                  </button>
                  <button class="bg-transparent border-2 border-white text-white hover:bg-white hover:text-bosch-blue-600 font-bosch-medium py-bosch-md px-bosch-lg rounded-bosch-md transition-all duration-200 hidden xl:block text-center" type="submit" name="submit" routerLink="my-links/">
                    Manage my links
                  </button>
                  @if (isHovered) {
                    <span class="text-white bg-bosch-red-500/20 backdrop-blur-sm px-bosch-md py-bosch-sm rounded-bosch-md text-sm font-bosch border border-bosch-red-400/30 animate-bosch-pulse">Only for internal usage</span>
                  }
                </div>
              </div>
            </div>
          }

        </div>

        <app-footer></app-footer>
      </div>
